// extracted by mini-css-extract-plugin
module.exports = {"title":"projectOverviewCarousel_title__3LPTk","container":"projectOverviewCarousel_container__gEEg_"};